import MD5 from 'strophe.js/src/md5';
import SASLMechanism from 'strophe.js/src/sasl';
import utils from 'strophe.js/src/utils';


export default class SASLMD5 extends SASLMechanism {

    /** PrivateConstructor: SASLMD5
     *  SASL DIGEST-MD5 authentication.
     */
    constructor(mechname = 'DIGEST-MD5', isClientFirst = true, priority = 30) {
        super(mechname, isClientFirst, priority);
    }

    test(connection) { // eslint-disable-line class-methods-use-this
        return connection.authcid !== null;
    }
    quote(str) {// eslint-disable-line class-methods-use-this
        return '"' + str.replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"';
        //" end string workaround for emacs
    };

    onChallenge(connection, challenge) { // eslint-disable-line class-methods-use-this
        let attribMatch = /([a-z]+)=("[^"]+"|[^,"]+)(?:,|$)/;
        const cnonce = connection._sasl_data.cnonce;
        let realm = "";
        let host = null;
        let nonce = "";
        let qop = "";
        let rspauth = "";

        while (challenge && challenge.match(attribMatch)) {
            const matches = challenge.match(attribMatch);
            challenge = challenge.replace(matches[0], "");
            matches[2] = matches[2].replace(/^"(.+)"$/, "$1");
            switch (matches[1]) {
                case "realm":
                    realm = matches[2];
                    break;
                case "nonce":
                    nonce = matches[2];
                    break;
                case "qop":
                    qop = matches[2];
                    break;
                case "host":
                    host = matches[2];
                case "rspauth":
                    rspauth = matches[2];
                    break;
            }
        }
        
        if (rspauth) {
            return "";
        }
        let digest_uri = connection.servtype + "/" + connection.domain;
        if (host !== null) {
            digest_uri = digest_uri + "/" + host;
        }

        let cred = utils.utf16to8(connection.authcid + ":" + realm + ":" + connection.pass);
        let A1 = MD5.hash(cred) + ":" + nonce + ":" + cnonce;
        let A2 = 'AUTHENTICATE:' + digest_uri;
        let responseText = "";
        responseText += 'charset=utf-8,';
        responseText += 'username=' + this.quote(utils.utf16to8(connection.authcid)) + ',';
        responseText += 'realm=' + this.quote(realm) + ',';
        responseText += 'nonce=' + this.quote(nonce) + ',';
        responseText += 'nc=00000001,';
        responseText += 'cnonce=' + this.quote(cnonce) + ',';
        responseText += 'digest-uri=' + this.quote(digest_uri) + ',';
        responseText += 'response=' + MD5.hexdigest(MD5.hexdigest(A1) + ":" +
            nonce + ":00000001:" +
            cnonce + ":auth:" +
            MD5.hexdigest(A2)) + ",";
        responseText += 'qop=auth';
        return responseText;
    }

    clientChallenge(connection, test_cnonce) {  // eslint-disable-line class-methods-use-this
        const cnonce = test_cnonce || MD5.hexdigest("" + (Math.random() * 1234567890));
        connection._sasl_data.cnonce = cnonce;
    }
}
